import { TransactionStatus } from 'fourwaves-shared';

export default {
  org_config: {
    events: {
      title: 'Events',
      name: 'Event name',
      new_event: 'Create New Event',
    },
    plan: {
      tab: 'Plan',
      title: 'Plan & Billing',
      summary: {
        title: 'Plan summary',
        invoices_due: 'Invoice(s) due:',
        empty_invoices: 'No invoices due',
        view_all_invoices: 'View all invoices',
        view_breakdown: 'View cost breakdown',
        invoice_button: 'View invoice | View invoices ({count})',
        price: 'Plan Cost:',
        term_length: 'Term length:',
        next_plan: 'Next Plan (Renewal):',
        next_invoice: 'Next invoice:',
        active_event: 'Active events',
        included_feature: 'Included in your plan',
        super_admin_renew: {
          title: 'Renew Plan',
          message: 'As a Super Admin, you can renew the plan at any time.',
        },
      },
      add_ons: 'Add-Ons',
      cancel: 'Cancel Plan',
      cancel_modal: {
        item: 'Plan',
        subtitle: 'By canceling this plan, the organization will be downgraded to a free plan',
        success_message: 'Organization has been downgraded to a free plan.',
      },
      cancel_contact_modal: {
        title: 'Contact us',
        subtitle:
          'To cancel your plan, please contact us at sales@fourwaves.com and we will assist you with your request.',
        cta: 'Contact us',
      },
      event_limit_alert: {
        title:
          "You've reached the limit of {count} active event for your current plan. | You've reached the limit of {count} active events for your current plan.",
        message: 'To publish additional events, add more events slots.',
      },
      event_limit_contact_alert: {
        title: "You've reached the limit of 10 active events for your current plan.",
        message: 'To add more events to your plan, contact us.',
        cta: 'Talk to Sales',
      },
      transactions: {
        title: 'Billing History',
        edit_item: 'Pay Invoice',
        empty_title: 'No purchases',
        empty_subtitle: 'There are no purchases related to this organization yet.',
      },
      edit_payment: {
        title: 'Edit Payment',
        update: 'Update payment',
        pay_now: 'Pay now',
        payment_success: 'Your payment has been processed successfully.',
        update_success: 'Your transaction has been updated successfully.',
      },
    },
    users: {
      title: 'Users',
      admins: {
        title: 'Organization Admins',
        hint: 'Admins can create, edit and clone events in your organization. They can also purchase upgrades for your events.',
        invite_modal_title: 'Add Administrator',
        remove_modal_title: 'Remove Administrator',
        remove_modal_subtitle: 'This administrator will no longer have access to the organization and its events.',
        empty_tile: 'No administrator have been added to this organization yet.',
      },
      organizers: {
        title: 'Event Organizers',
        event_count: 'Linked to {count} event | Linked to {count} events',
        empty_tile: 'No organizer have been added to an event of this organization.',
        hint: 'Event organizers have access only to specific events and are able to edit them. They cannot create events, clone events or purchase upgrades.',
      },
      events_modal: {
        title: '{name} Events',
      },
    },
    settings: {
      title: 'Settings',
      organization: 'Organization',
      api: 'API Keys',
      infos: {
        title: 'Organization Info',
        name: 'Name',
        name_hint: 'Be as specific as possible. Ex. Department of Marine Biology of the Brightwater University.',
        address: 'Street Address',
        address_hint: 'Required to publish your events, upgrade your plan, etc.',
        city: 'City',
        zip: 'Postal / Zip Code',
      },
      api_keys: {
        title: 'API Keys',
        hint: 'View our <a href="https://api.fourwaves.com/documentation">documentation</a> to learn more about how to use your API key.',
        empty_tile: 'No API keys have been added to this organisation yet.',
        delete_modal_title: 'API key',
        delete_modal_subtitle: 'This API key will be deactivated. This action is permanent and cannot be undone.',
        create_modal_title: 'Create a new API key',
        create_modal_name: 'Name',
      },
    },
    transactions: {
      title: 'Transactions',
      empty_title: 'No transactions',
      empty_subtitle: 'There are no transactions related to this organization yet.',
    },
    transaction_status: {
      [TransactionStatus.Concluded]: 'Paid',
      [TransactionStatus.Pending]: 'Payment Pending',
    },
    pg: {
      index: {
        title: 'Payment Gateways',
        empty_title: 'No payment gateways',
        empty_subtitle: 'There are no payment gateways linked to this organization at the moment.',
        connect: 'Connect',
        name: 'Name',
        events_connected: 'Events Connected',
        payment_gateway: 'Provider',
        code: 'Gateway Code',
        clipboard_success_message: 'Code copied to clipboard',
      },
      detail: {
        back_to_index: 'Back to all Payment Gateways',
        settings: {
          title: 'Settings',
          account_title: 'General Info',
          name: 'Payment Gateway Name',
          gateway_hint:
            'Share this code with your organizers to allow them to connect their events to this Payment Gateway.',
          billing: 'Billing Info',
          tax: 'Tax ID',
          payment_title: 'Provider',
        },
        form: {
          title: 'Connection Form',
          empty_subtitle:
            'Customize this form so that event organizers can request connection to this payment gateway.',
        },
        requests: {
          title: 'Connection History ',
          empty_title: 'No connected events',
          empty_subtitle: 'This payment gateway has not been linked to any event yet.',
          event_name: 'Event Name',
          state: 'Status',
          edit_state: 'Last Status Change',
          decision_by: 'Decision By',
          request_date: 'Request Date',
          request_by: 'Request By',
          request_by_email: 'Requester email',
          external_event_title: 'This event is external to your organization.',
          external_event_subtitle: 'You do not have the required permissions to access it.',
        },
      },
    },
    missing_info_modal: {
      title: 'Information Missing',
      subtitle:
        "Your organization's settings is missing a billing address. Please update this information before you can purchase an upgrade.",
      cta: 'Go to Settings',
    },
    invoice: {
      back_to_list: 'Back to all invoices',
      pay: 'Pay now',
      company_address: '<p>PO Box 4, Section C</p> <p>Montreal, H2L 4J7</p> <p>Canada, Quebec</p>',
      organization: 'Organization',
      bank_transfer: 'Bank transfer',
      bank_transfer_infos_usd:
        '<div><p>Bank name: Fédération des caisses Desjardins du Québec</p><p>100 rue des Commandeurs</p><p>Lévis, Québec, Canada</p><p>G1V 7N5</p></div><div><p>Transit: 30008</p><p>Institution: 815</p><p>Account No.: 8005647</p><p>BIC/SWIFT: CCDQAMM</p><p>Routing number: 081530008</p></div>',
      bank_transfer_infos_cad:
        '<div><p>Bank name: Fédération des caisses Desjardins du Québec</p><p>100 rue des Commandeurs</p><p>Lévis, Québec, Canada</p><p>G1V 7N5</p></div><div><p>Transit: 30008</p><p>Institution: 815</p><p>Account No.: 2288058</p><p>BIC/SWIFT: CCDQAMM</p><p>Routing number: 081530008</p></div>',
      bank_transfer_infos_eur:
        '<div><p>Bank name: Wise</p><p>Rue du Trône 100, 3rd floor</p><p>Brussels, 1050, Belgium</p></div><div><p>IBAN: BE38967181924472</p><p>BIC/SWIFT: TRWIBEB1XXX</p></div>',
      check: 'Check',
      send_check:
        'Send a check labeled to Fourwaves to:<br/> Fourwaves, PO Box 4, Section C, Montreal, Quebec, H2L 4J7, Canada.',
      send_payment_notification: 'Send a payment notification to {email} with the invoice number and the payment date.',
      accounting_email: 'accounting@fourwaves.com',
      mark_as_paid: {
        button: 'Mark as Paid',
        modal_message: 'Are you sure you want to mark this invoice as paid?',
      },
    },
  },
};
